// extracted by mini-css-extract-plugin
module.exports = {"root":"Notes_root__2yvwp","notes":"Notes_notes__2luaA"};